export const urlDataFetchingSelector = state => state.urlData.fetching;
export const urlDataSelector = state => state.urlData.data;
export const urlDataLpsSelector = state => state.urlData.data.linkProfileStrength;
